import { Event } from "../Event";

export class UserCustomSalaryEvents extends Event {
    // public onChange = (value: any, setField: any, setState: any, formValues: any) => {

    // }

    // public onBlur = (value: any, setField: any, setState: any, formValues: any) => {
    // }
}